import PropTypes from "prop-types";
import ToolTip from "../../../../../parts/tooltip";

/**
 * Single histogram bar column track; shows a tooltip on hover when `count > 0`.
 */
function InsightsChartBarWithTooltip({
  count,
  heightPct,
  tooltipId,
  tooltipBody,
  wrapClassName,
  barClassName,
  barStyle,
}) {
  const barWrap = (
    <div className={wrapClassName}>
      <div
        className={barClassName}
        style={{ height: `${heightPct}%`, ...barStyle }}
      />
    </div>
  );

  if (count <= 0 || !tooltipBody) {
    return barWrap;
  }

  return (
    <ToolTip
      id={tooltipId}
      body={tooltipBody}
      place="top"
      className="ProgramInsights-chartBarTooltip"
      hintClassNames="ProgramInsights-chartBarTooltipHint"
    >
      {barWrap}
    </ToolTip>
  );
}

InsightsChartBarWithTooltip.propTypes = {
  barClassName: PropTypes.string.isRequired,
  barStyle: PropTypes.object,
  count: PropTypes.number.isRequired,
  heightPct: PropTypes.number.isRequired,
  tooltipBody: PropTypes.string,
  tooltipId: PropTypes.string.isRequired,
  wrapClassName: PropTypes.string.isRequired,
};

export default InsightsChartBarWithTooltip;
